// /* global THREE */
import aframe from "aframe";

aframe.registerComponent("ammo", {
  schema: {
    count: { type: "int", default: 10, min: 0 },
    max: { type: "int", default: 10, min: 0 },
    container: { type: "selector" }
  },
  init() {
    this.containerObj = this.el.object3D;
    this._findContainerObj = this._findContainerObj.bind(this);
  },
  update: function (oldData) {
    if (this.data.container !== oldData.container) {
      const oldContainer = oldData.container || this.el;
      const newContainer = this.data.container || this.el;
      oldContainer.removeEventListener("model-loaded", this._findContainerObj);
      newContainer.addEventListener("model-loaded", this._findContainerObj);
      this._findContainerObj();
    }

    this._updateAmmo();
  },
  _findContainerObj() {
    let found = false;
    const containerEl = this.data.container || this.el;
    containerEl.object3D.traverse(o => {
      if (found) return;
      if (o.children.length >= this.data.max) {
        this.containerObj = o;
        found = true;
      }
    });
    if (found) {
      containerEl.removeEventListener("model-loaded", this._findContainerObj);
    } else {
      this.containerObj = undefined;
    }
    this._updateAmmo();
  },
  _updateAmmo() {
    if (this.containerObj === undefined) return;

    const max = this.containerObj.children.length;

    const isOptimised = this.containerObj.children[0].name.includes('ammo');

    for (let i = 0; i < max; i++) {
      const child = this.containerObj.children[i];

      if (isOptimised) {
        const targetName = `ammo${this.data.count}`;
        child.visible = child.name === targetName;
      } else {
        if (i < this.data.count) {
          child.visible = true;
        } else {
          child.visible = false;
        }
      }
    }
  }
});
